export const USER_TOKEN = "user_token";
export const USER_INFO = "user_info";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js